import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Button, Box } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
    handlebutton: string;
}

export const ContentCard = styled('div')(
    ({ theme }: { theme?: Theme; }) => `
    display: grid;
    grid-template-rows: 1fr;
    textAlign: left;
    padding: .9rem .8rem 1.7rem;
    border-radius: .5rem;
    border: 1px solid #0AA8E3;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        border-radius: .38619rem;
        padding: .88rem .8rem 1rem 1.28rem;
        grid-template-rows: 4.5rem 9rem 1.6rem 3.2rem;
    }
`);

export const RiskGreen = styled('div')(
    ({ theme }: { theme?: Theme; }) => `
        display: flex;
        margin: .5rem 0;
        align-items: end;

        div {
            width: 3.5rem;
            height: .2rem;
            background-color: ${theme?.palette.secondary.main};
        }

        span {
            height: 1px;
            width: calc(100% - 3.5rem);
            display: block;
            background-color: #ECECEC;
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            div {
                width: 2.56rem;
            }

            span {
                width: calc(100% - 2.56rem);
            }
        }
`);

export const ContentList = styled('ul')(
    ({ theme }: { theme?: Theme; }) => `
        display: flex;
        gap: 0;
        flex-wrap: wrap;
        flex-direction: column;

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            gap: .1rem;
        }
`);

export const ButtonCustom = styled(Button)(
    ({ theme, handlebutton }: ParamsStyle) => `
        margin-top: .6rem;
        width: 100%;
        height: 2.18rem;
        font-weight: 700;
        transition: 800ms;
        border: 2px solid ${theme?.palette.primary.main};
        color: ${handlebutton === 'add' ? 'white' : theme?.palette.primary.main};
        background-color: ${handlebutton === 'add' ? theme?.palette.primary.main : 'white'};
        
        :hover {
            background-color: ${handlebutton === 'add' ? theme?.palette.primary.main : 'white'};
        }

        &.individual {
            border: 2px solid ${theme?.palette.primary.light};
            color: ${handlebutton === 'add' ? 'white' : theme?.palette.primary.light};
            background-color: ${handlebutton === 'add' ? theme?.palette.primary.light : 'white'};

            :hover {
                background-color: ${handlebutton === 'add' ? theme?.palette.primary.light : 'white'};
            }
        }

        &.contratado {
            border: 2px solid ${theme?.palette.secondary.main};
            color: ${handlebutton === 'add' ? 'white' : theme?.palette.secondary.main};
            background-color: ${handlebutton === 'add' ? theme?.palette.secondary.main : 'white'};

            :hover {
                background-color: ${handlebutton === 'add' ? theme?.palette.secondary.main : 'white'};
            }

            pointer-events: none;
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            border: 2px solid ${theme?.palette.primary.light};
            color: ${handlebutton === 'add' ? 'white' : theme?.palette.primary.light};
            background-color: ${handlebutton === 'add' ? theme?.palette.primary.light : 'white'};

            :hover {
                background-color: ${handlebutton === 'add' ? theme?.palette.primary.light : 'white'};
            }
        }
`);

export const ButtonClosed = styled(Box)(
    ({ theme }: { theme?: Theme; }) => `
    width: 1.56rem;
    height: 1.56rem;
    cursor: pointer;
    border-radius: 100px;
    position: absolute;
    top: .7rem;
    right: 1.24rem;
    border: 1px solid ${theme?.palette.primary.main}; 
    
    svg { 
        width: auto;
        height: auto;
    } 
`);